import React from "react";
import {
    Button,
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    makeStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
    instructionsList: {
        marginTop: "8px",
        paddingLeft: "20px",
    },
});

interface HelpDialogProps {
    open: boolean;
    onClose: () => void;
}

export function HelpDialog({ open, onClose }: HelpDialogProps) {
    const styles = useStyles();

    return (
        <Dialog
            open={open}
            onOpenChange={(event, data) => !data.open && onClose()}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>How to Play:</DialogTitle>
                    <DialogContent>
                        <ul className={styles.instructionsList}>
                            <li>Use all numbers exactly once</li>
                            <li>Numbers must be used in order</li>
                            <li>Create an expression that equals 10</li>
                            <li>Supported operations: + - * / ^ !</li>
                            <li>
                                You can use two adjacent numbers to make a 2
                                digit number. 1265 could be (12/6)*5 = 10
                            </li>
                            <li>Example: 61941 could be (6-1!+9-4)^1 = 10</li>
                        </ul>
                    </DialogContent>
                    <DialogActions>
                        <Button appearance="primary" onClick={onClose}>
                            Got it!
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}
